var _objectSpread = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).BloctoSDK = e();
}(this, function () {
  "use strict";

  var t = "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {};
  function e() {
    throw new Error("setTimeout has not been defined");
  }
  function n() {
    throw new Error("clearTimeout has not been defined");
  }
  var r = e,
    o = n;
  function i(t) {
    if (r === setTimeout) return setTimeout(t, 0);
    if ((r === e || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0);
    try {
      return r(t, 0);
    } catch (e) {
      try {
        return r.call(null, t, 0);
      } catch (e) {
        return r.call(this, t, 0);
      }
    }
  }
  "function" == typeof t.setTimeout && (r = setTimeout), "function" == typeof t.clearTimeout && (o = clearTimeout);
  var s,
    a = [],
    c = !1,
    h = -1;
  function u() {
    c && s && (c = !1, s.length ? a = s.concat(a) : h = -1, a.length && f());
  }
  function f() {
    if (!c) {
      var t = i(u);
      c = !0;
      for (var e = a.length; e;) {
        for (s = a, a = []; ++h < e;) s && s[h].run();
        h = -1, e = a.length;
      }
      s = null, c = !1, function (t) {
        if (o === clearTimeout) return clearTimeout(t);
        if ((o === n || !o) && clearTimeout) return o = clearTimeout, clearTimeout(t);
        try {
          o(t);
        } catch (e) {
          try {
            return o.call(null, t);
          } catch (e) {
            return o.call(this, t);
          }
        }
      }(t);
    }
  }
  function l(t, e) {
    this.fun = t, this.array = e;
  }
  l.prototype.run = function () {
    this.fun.apply(null, this.array);
  };
  function d() {}
  var p = d,
    g = d,
    w = d,
    y = d,
    m = d,
    v = d,
    b = d;
  var E = t.performance || {},
    A = E.now || E.mozNow || E.msNow || E.oNow || E.webkitNow || function () {
      return new Date().getTime();
    };
  var T = new Date();
  var R = {
      nextTick: function (t) {
        var e = new Array(arguments.length - 1);
        if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
        a.push(new l(t, e)), 1 !== a.length || c || i(f);
      },
      title: "browser",
      browser: !0,
      env: {},
      argv: [],
      version: "",
      versions: {},
      on: p,
      addListener: g,
      once: w,
      off: y,
      removeListener: m,
      removeAllListeners: v,
      emit: b,
      binding: function (t) {
        throw new Error("process.binding is not supported");
      },
      cwd: function () {
        return "/";
      },
      chdir: function (t) {
        throw new Error("process.chdir is not supported");
      },
      umask: function () {
        return 0;
      },
      hrtime: function (t) {
        var e = .001 * A.call(E),
          n = Math.floor(e),
          r = Math.floor(e % 1 * 1e9);
        return t && (n -= t[0], (r -= t[1]) < 0 && (n--, r += 1e9)), [n, r];
      },
      platform: "browser",
      release: {},
      config: {},
      uptime: function () {
        return (new Date() - T) / 1e3;
      }
    },
    S = R,
    P = function (t, e, n, r, o, i, s, a) {
      if ("production" !== S.env.NODE_ENV && void 0 === e) throw new Error("invariant requires an error message argument");
      if (!t) {
        var c;
        if (void 0 === e) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var h = [n, r, o, i, s, a],
            u = 0;
          (c = new Error(e.replace(/%s/g, function () {
            return h[u++];
          }))).name = "Invariant Violation";
        }
        throw c.framesToPop = 1, c;
      }
    };
  const _ = {
      56: "https://bsc-dataseed1.binance.org",
      97: "https://data-seed-prebsc-1-s1.binance.org:8545",
      137: "https://rpc-mainnet.maticvigil.com/",
      80001: "https://rpc-mumbai.matic.today/",
      43114: "https://api.avax.network/ext/bc/C/rpc",
      43113: "https://api.avax-test.network/ext/bc/C/rpc"
    },
    I = {
      1: "ethereum",
      4: "ethereum",
      56: "bsc",
      97: "bsc",
      137: "polygon",
      80001: "polygon",
      43114: "avalanche",
      43113: "avalanche"
    },
    B = {
      1: "mainnet",
      4: "rinkeby",
      56: "mainnet",
      97: "testnet",
      137: "mainnet",
      80001: "testnet",
      43114: "mainnet",
      43113: "testnet"
    },
    C = {
      1: "https://wallet.blocto.app",
      4: "https://wallet-dev.blocto.app",
      56: "https://wallet.blocto.app",
      97: "https://wallet-dev.blocto.app",
      137: "https://wallet.blocto.app",
      80001: "https://wallet-dev.blocto.app",
      43114: "https://wallet.blocto.app",
      43113: "https://wallet-dev.blocto.app"
    },
    O = {
      devnet: "https://wallet-dev.blocto.app",
      testnet: "https://wallet-dev.blocto.app",
      "mainnet-beta": "https://wallet.blocto.app"
    },
    U = ["devnet", "testnet", "mainnet-beta"],
    M = {
      1: "https://wallet.blocto.app",
      2: "https://wallet-dev.blocto.app",
      3: "https://wallet-dev.blocto.app",
      4: "https://wallet-dev.blocto.app",
      5: "https://wallet.blocto.app"
    };
  var L;
  !function (t) {
    t.Mainnet = "mainnet", t.Testnet = "testnet", t.Devnet = "devnet", t.Testing = "testing", t.Premainnet = "premainnet";
  }(L || (L = {}));
  const D = {
      1: L.Mainnet,
      2: L.Testnet,
      3: L.Devnet,
      4: L.Testing,
      5: L.Premainnet
    },
    N = {
      1: "https://fullnode.mainnet.aptoslabs.com/v1",
      2: "https://fullnode.testnet.aptoslabs.com/v1",
      3: "https://fullnode.devnet.aptoslabs.com/v1",
      4: "",
      5: "https://premainnet.aptosdev.com/v1"
    },
    k = ["connect", "disconnect", "message", "chainChanged", "accountsChanged"],
    x = 864e5,
    Y = "sdk.session";
  class $ {
    constructor() {
      this.isBlocto = !0, this.isConnecting = !1, this.connected = !1, this.eventListeners = {}, this.code = null, this.sessionKey = Y, this.off = this.removeListener, k.forEach(t => {
        this.eventListeners[t] = [];
      });
    }
    async request(t) {}
    on(t, e) {
      k.includes(t) && this.eventListeners[t].push(e);
    }
    once() {}
    removeListener(t, e) {
      const n = this.eventListeners[t].findIndex(t => t === e);
      -1 !== n && this.eventListeners[t].splice(n, 1);
    }
  }
  function j(t) {
    const e = document.createElement("iframe");
    return e.setAttribute("src", t), e.setAttribute("style", "width:100vw;height:100%;position:fixed;top:0;left:0;z-index:20000;border:none;"), e;
  }
  function K(t) {
    document.body.appendChild(t);
  }
  function F(t) {
    const e = t && t.parentNode;
    e && e.removeChild instanceof Function && e.removeChild(t);
  }
  var q = function (t, e) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
    n.addEventListener(t, function r(o) {
      e(o, () => n.removeEventListener(t, r));
    });
  };
  const z = "undefined" != typeof window ? window.memoryStorage : new class {
    constructor() {
      this.storage = {};
    }
    getItem(t) {
      return this[t] || null;
    }
    setItem(t, e) {
      this.storage[t] = e;
    }
    removeItem(t) {
      delete this.storage[t];
    }
  }();
  "undefined" != typeof window && (window.memoryStorage = z);
  const V = (() => {
      if ("undefined" == typeof window) return !1;
      try {
        window.localStorage.setItem("local_storage_supported", "1");
        const t = window.localStorage.getItem("local_storage_supported");
        return window.localStorage.removeItem("local_storage_supported"), "1" === t;
      } catch (t) {
        return !1;
      }
    })() ? window.localStorage : z,
    H = function (t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      const n = function (t) {
        let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        const n = V.getItem(t);
        try {
          return JSON.parse(n) || e;
        } catch (t) {
          return n || e;
        }
      }(t, null);
      return n ? new Date().getTime() > n.expiry ? (G(t), e) : n.value : e;
    },
    W = (t, e) => V.setItem(t, "string" == typeof e ? e : JSON.stringify(e)),
    J = (t, e, n) => W(t, {
      value: e,
      expiry: new Date().getTime() + n
    }),
    G = t => {
      W(t, ""), V.removeItem(t);
    };
  async function X(t, e) {
    if (403 === t.status) throw e.code = null, G(e.sessionKey), new Error("[Blocto SDK]: Session expired!");
    return t.json();
  }
  class Z extends $ {
    constructor(_ref) {
      let {
        chainId: t = "0x1",
        rpc: e,
        server: n,
        appId: r
      } = _ref;
      super(), this.accounts = [], P(t, "'chainId' is required"), "number" == typeof t ? this.chainId = t : t.includes("0x") ? this.chainId = parseInt(t, 16) : this.chainId = parseInt(t, 10), this.networkId = this.chainId, this.chain = I[this.chainId], this.net = B[this.chainId], P(this.chain, "unsupported 'chainId': ".concat(this.chainId)), this.rpc = e || _[this.chainId] || process.env.RPC || "", P(this.rpc, "'rpc' is required for Ethereum"), this.server = n || C[this.chainId] || process.env.SERVER || "", this.appId = r || process.env.APP_ID;
    }
    tryRetrieveSessionFromStorage() {
      const t = H(this.sessionKey, {}),
        e = t && t.code,
        n = t && t.address && t.address[this.chain];
      this.connected = Boolean(e && n), this.code = e || null, this.accounts = n ? [n] : [];
    }
    checkNetworkMatched() {
      const t = window.ethereum;
      if (t && t.isBlocto && parseInt(t.chainId, 16) !== this.chainId) throw new Error("Blocto SDK network mismatched");
    }
    async send(t, e) {
      switch (!0) {
        case e instanceof Function:
          return this.sendAsync(t, e);
        case "string" == typeof t && Array.isArray(e):
          return this.sendAsync({
            method: t,
            params: e
          });
        default:
          return this.sendAsync(t);
      }
    }
    async sendAsync(t, e) {
      const n = new Promise(e => {
        if (Array.isArray(t)) {
          const n = t.filter(t => "eth_sendTransaction" === t.method).map(t => t.params[0]),
            r = Math.floor(1e4 * Math.random()),
            o = {
              method: "blocto_sendBatchTransaction",
              params: n
            },
            i = this.request(o),
            s = t.map((_ref2, n) => {
              let {
                method: t,
                params: e
              } = _ref2;
              return "eth_sendTransaction" === t ? i : this.request({
                id: r + n + 1,
                jsonrpc: "2.0",
                method: t,
                params: e
              });
            });
          Promise.allSettled(s).then(t => e(t.map((t, e) => ({
            id: r + e + 1,
            jsonrpc: "2.0",
            result: "fulfilled" === t.status ? t.value : void 0,
            error: "fulfilled" !== t.status ? t.reason : void 0
          }))));
        } else this.request(t).then(e);
      });
      if (!e) return n;
      n.then(t => e(null, t)).catch(t => e(t));
    }
    async request(t) {
      const e = window.ethereum;
      if (e && e.isBlocto) return e.request(t);
      this.connected || (await this.enable());
      try {
        let e = null,
          n = null;
        switch (t.method) {
          case "eth_requestAccounts":
            this.accounts = await this.fetchAccounts();
          case "eth_accounts":
            n = this.accounts;
            break;
          case "eth_coinbase":
            n = this.accounts[0];
            break;
          case "eth_chainId":
            n = this.chainId, n = "0x".concat(n.toString(16));
            break;
          case "net_version":
            n = this.networkId || this.chainId, n = "0x".concat(n.toString(16));
            break;
          case "eth_signTypedData_v3":
          case "eth_signTypedData":
          case "eth_signTypedData_v4":
          case "personal_sign":
          case "eth_sign":
            n = await this.handleSign(t);
            break;
          case "wallet_disconnect":
            this.handleDisconnect(), n = null;
            break;
          case "blocto_sendBatchTransaction":
          case "eth_sendTransaction":
            n = await this.handleSendTransaction(t);
            break;
          case "eth_signTransaction":
          case "eth_sendRawTransaction":
            n = null;
            break;
          default:
            e = await this.handleReadRequests(t);
        }
        if (e && !e.result && e.error) {
          const t = e.error.message ? e.error.message : "Request failed";
          throw new Error(t);
        }
        return e ? e.result : n;
      } catch (t) {
        throw console.error(t), t;
      }
    }
    async enable() {
      const t = window.ethereum;
      if (t && t.isBlocto) {
        if (parseInt(t.chainId, 16) !== this.chainId) try {
          await t.request({
            method: "wallet_addEthereumChain",
            params: [{
              chainId: "0x".concat(this.chainId.toString(16))
            }]
          }), this.accounts = [t.address];
        } catch (t) {
          console.error(t);
        }
        return new Promise((e, n) => setTimeout(() => t.enable().then(e).catch(n), 10));
      }
      return this.tryRetrieveSessionFromStorage(), new Promise((t, e) => {
        if ("undefined" == typeof window && e("Currently only supported in browser"), this.connected) return t(this.accounts);
        const n = encodeURIComponent(window.location.origin),
          r = j("".concat(this.server, "/authn?l6n=").concat(n, "&chain=").concat(this.chain));
        K(r), q("message", (n, o) => {
          const i = n;
          if (i.origin === this.server) {
            if ("FCL::CHALLENGE::RESPONSE" === i.data.type) {
              o(), F(r), this.code = i.data.code, this.connected = !0, this.eventListeners.connect.forEach(t => t(this.chainId));
              const e = i.data.address;
              this.accounts = e ? [e[this.chain]] : [], J(this.sessionKey, {
                code: this.code,
                address: e
              }, x), t(this.accounts);
            }
            "FCL::CHALLENGE::CANCEL" === i.data.type && (o(), F(r), e(new Error("User declined the login request")));
          }
        });
      });
    }
    async fetchAccounts() {
      this.checkNetworkMatched();
      const {
        accounts: t
      } = await fetch("".concat(this.server, "/api/").concat(this.chain, "/accounts?code=").concat(this.code)).then(t => X(t, this));
      return this.accounts = t, t;
    }
    async handleReadRequests(t) {
      return this.checkNetworkMatched(), fetch(this.rpc, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(_objectSpread({
          id: 1,
          jsonrpc: "2.0"
        }, t))
      }).then(t => t.json());
    }
    async handleSign(_ref3) {
      let {
        method: t,
        params: e
      } = _ref3;
      const n = "".concat(this.server, "/user-signature/").concat(this.chain),
        r = j(n);
      K(r);
      let o = "";
      return Array.isArray(e) && ("eth_sign" === t ? o = e[1].slice(2) : "personal_sign" === t ? o = e[0].slice(2) : ["eth_signTypedData", "eth_signTypedData_v3", "eth_signTypedData_v4"].includes(t) && (o = e[1])), q("message", (e, i) => {
        const s = e;
        s.origin === this.server && "ETH:FRAME:READY" === s.data.type && (r.contentWindow && r.contentWindow.postMessage({
          type: "ETH:FRAME:READY:RESPONSE",
          method: t,
          message: o,
          chain: this.chain
        }, n), i());
      }), new Promise((t, e) => q("message", (n, o) => {
        const i = n;
        i.origin === this.server && "ETH:FRAME:RESPONSE" === i.data.type && ("APPROVED" === i.data.status && (o(), F(r), t(i.data.signature)), "DECLINED" === i.data.status && (o(), F(r), e(new Error(i.data.errorMessage))));
      }));
    }
    async handleSendTransaction(t) {
      this.checkNetworkMatched();
      const {
        authorizationId: e
      } = await fetch("".concat(this.server, "/api/").concat(this.chain, "/authz?code=").concat(this.code), {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(t.params)
      }).then(t => X(t, this));
      if ("undefined" == typeof window) throw new Error("Currently only supported in browser");
      const n = j("".concat(this.server, "/authz/").concat(this.chain, "/").concat(e));
      return K(n), new Promise((t, e) => q("message", (r, o) => {
        const i = r;
        i.origin === this.server && "ETH:FRAME:RESPONSE" === i.data.type && ("APPROVED" === i.data.status && (o(), F(n), t(i.data.txHash)), "DECLINED" === i.data.status && (o(), F(n), e(new Error(i.data.errorMessage))));
      }));
    }
    async handleDisconnect() {
      this.connected = !1, this.code = null, this.accounts = [], G(Y);
    }
  }
  var Q = [],
    tt = [],
    et = "undefined" != typeof Uint8Array ? Uint8Array : Array,
    nt = !1;
  function rt() {
    nt = !0;
    for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = 0, n = t.length; e < n; ++e) Q[e] = t[e], tt[t.charCodeAt(e)] = e;
    tt["-".charCodeAt(0)] = 62, tt["_".charCodeAt(0)] = 63;
  }
  function ot(t, e, n) {
    for (var r, o, i = [], s = e; s < n; s += 3) r = (t[s] << 16) + (t[s + 1] << 8) + t[s + 2], i.push(Q[(o = r) >> 18 & 63] + Q[o >> 12 & 63] + Q[o >> 6 & 63] + Q[63 & o]);
    return i.join("");
  }
  function it(t) {
    var e;
    nt || rt();
    for (var n = t.length, r = n % 3, o = "", i = [], s = 16383, a = 0, c = n - r; a < c; a += s) i.push(ot(t, a, a + s > c ? c : a + s));
    return 1 === r ? (e = t[n - 1], o += Q[e >> 2], o += Q[e << 4 & 63], o += "==") : 2 === r && (e = (t[n - 2] << 8) + t[n - 1], o += Q[e >> 10], o += Q[e >> 4 & 63], o += Q[e << 2 & 63], o += "="), i.push(o), i.join("");
  }
  function st(t, e, n, r, o) {
    var i,
      s,
      a = 8 * o - r - 1,
      c = (1 << a) - 1,
      h = c >> 1,
      u = -7,
      f = n ? o - 1 : 0,
      l = n ? -1 : 1,
      d = t[e + f];
    for (f += l, i = d & (1 << -u) - 1, d >>= -u, u += a; u > 0; i = 256 * i + t[e + f], f += l, u -= 8);
    for (s = i & (1 << -u) - 1, i >>= -u, u += r; u > 0; s = 256 * s + t[e + f], f += l, u -= 8);
    if (0 === i) i = 1 - h;else {
      if (i === c) return s ? NaN : 1 / 0 * (d ? -1 : 1);
      s += Math.pow(2, r), i -= h;
    }
    return (d ? -1 : 1) * s * Math.pow(2, i - r);
  }
  function at(t, e, n, r, o, i) {
    var s,
      a,
      c,
      h = 8 * i - o - 1,
      u = (1 << h) - 1,
      f = u >> 1,
      l = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
      d = r ? 0 : i - 1,
      p = r ? 1 : -1,
      g = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
    for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = u) : (s = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -s)) < 1 && (s--, c *= 2), (e += s + f >= 1 ? l / c : l * Math.pow(2, 1 - f)) * c >= 2 && (s++, c /= 2), s + f >= u ? (a = 0, s = u) : s + f >= 1 ? (a = (e * c - 1) * Math.pow(2, o), s += f) : (a = e * Math.pow(2, f - 1) * Math.pow(2, o), s = 0)); o >= 8; t[n + d] = 255 & a, d += p, a /= 256, o -= 8);
    for (s = s << o | a, h += o; h > 0; t[n + d] = 255 & s, d += p, s /= 256, h -= 8);
    t[n + d - p] |= 128 * g;
  }
  var ct = {}.toString,
    ht = Array.isArray || function (t) {
      return "[object Array]" == ct.call(t);
    };
  dt.TYPED_ARRAY_SUPPORT = void 0 === t.TYPED_ARRAY_SUPPORT || t.TYPED_ARRAY_SUPPORT;
  var ut = ft();
  function ft() {
    return dt.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
  }
  function lt(t, e) {
    if (ft() < e) throw new RangeError("Invalid typed array length");
    return dt.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = dt.prototype : (null === t && (t = new dt(e)), t.length = e), t;
  }
  function dt(t, e, n) {
    if (!(dt.TYPED_ARRAY_SUPPORT || this instanceof dt)) return new dt(t, e, n);
    if ("number" == typeof t) {
      if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
      return wt(this, t);
    }
    return pt(this, t, e, n);
  }
  function pt(t, e, n, r) {
    if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
    return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, n, r) {
      if (e.byteLength, n < 0 || e.byteLength < n) throw new RangeError("'offset' is out of bounds");
      if (e.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
      e = void 0 === n && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, n) : new Uint8Array(e, n, r);
      dt.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = dt.prototype : t = yt(t, e);
      return t;
    }(t, e, n, r) : "string" == typeof e ? function (t, e, n) {
      "string" == typeof n && "" !== n || (n = "utf8");
      if (!dt.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
      var r = 0 | bt(e, n);
      t = lt(t, r);
      var o = t.write(e, n);
      o !== r && (t = t.slice(0, o));
      return t;
    }(t, e, n) : function (t, e) {
      if (vt(e)) {
        var n = 0 | mt(e.length);
        return 0 === (t = lt(t, n)).length || e.copy(t, 0, 0, n), t;
      }
      if (e) {
        if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (r = e.length) != r ? lt(t, 0) : yt(t, e);
        if ("Buffer" === e.type && ht(e.data)) return yt(t, e.data);
      }
      var r;
      throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
    }(t, e);
  }
  function gt(t) {
    if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
    if (t < 0) throw new RangeError('"size" argument must not be negative');
  }
  function wt(t, e) {
    if (gt(e), t = lt(t, e < 0 ? 0 : 0 | mt(e)), !dt.TYPED_ARRAY_SUPPORT) for (var n = 0; n < e; ++n) t[n] = 0;
    return t;
  }
  function yt(t, e) {
    var n = e.length < 0 ? 0 : 0 | mt(e.length);
    t = lt(t, n);
    for (var r = 0; r < n; r += 1) t[r] = 255 & e[r];
    return t;
  }
  function mt(t) {
    if (t >= ft()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + ft().toString(16) + " bytes");
    return 0 | t;
  }
  function vt(t) {
    return !(null == t || !t._isBuffer);
  }
  function bt(t, e) {
    if (vt(t)) return t.length;
    if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
    "string" != typeof t && (t = "" + t);
    var n = t.length;
    if (0 === n) return 0;
    for (var r = !1;;) switch (e) {
      case "ascii":
      case "latin1":
      case "binary":
        return n;
      case "utf8":
      case "utf-8":
      case void 0:
        return Ht(t).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return 2 * n;
      case "hex":
        return n >>> 1;
      case "base64":
        return Wt(t).length;
      default:
        if (r) return Ht(t).length;
        e = ("" + e).toLowerCase(), r = !0;
    }
  }
  function Et(t, e, n) {
    var r = !1;
    if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
    if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
    if ((n >>>= 0) <= (e >>>= 0)) return "";
    for (t || (t = "utf8");;) switch (t) {
      case "hex":
        return Nt(this, e, n);
      case "utf8":
      case "utf-8":
        return Ut(this, e, n);
      case "ascii":
        return Lt(this, e, n);
      case "latin1":
      case "binary":
        return Dt(this, e, n);
      case "base64":
        return Ot(this, e, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return kt(this, e, n);
      default:
        if (r) throw new TypeError("Unknown encoding: " + t);
        t = (t + "").toLowerCase(), r = !0;
    }
  }
  function At(t, e, n) {
    var r = t[e];
    t[e] = t[n], t[n] = r;
  }
  function Tt(t, e, n, r, o) {
    if (0 === t.length) return -1;
    if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = o ? 0 : t.length - 1), n < 0 && (n = t.length + n), n >= t.length) {
      if (o) return -1;
      n = t.length - 1;
    } else if (n < 0) {
      if (!o) return -1;
      n = 0;
    }
    if ("string" == typeof e && (e = dt.from(e, r)), vt(e)) return 0 === e.length ? -1 : Rt(t, e, n, r, o);
    if ("number" == typeof e) return e &= 255, dt.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(t, e, n) : Uint8Array.prototype.lastIndexOf.call(t, e, n) : Rt(t, [e], n, r, o);
    throw new TypeError("val must be string, number or Buffer");
  }
  function Rt(t, e, n, r, o) {
    var i,
      s = 1,
      a = t.length,
      c = e.length;
    if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
      if (t.length < 2 || e.length < 2) return -1;
      s = 2, a /= 2, c /= 2, n /= 2;
    }
    function h(t, e) {
      return 1 === s ? t[e] : t.readUInt16BE(e * s);
    }
    if (o) {
      var u = -1;
      for (i = n; i < a; i++) if (h(t, i) === h(e, -1 === u ? 0 : i - u)) {
        if (-1 === u && (u = i), i - u + 1 === c) return u * s;
      } else -1 !== u && (i -= i - u), u = -1;
    } else for (n + c > a && (n = a - c), i = n; i >= 0; i--) {
      for (var f = !0, l = 0; l < c; l++) if (h(t, i + l) !== h(e, l)) {
        f = !1;
        break;
      }
      if (f) return i;
    }
    return -1;
  }
  function St(t, e, n, r) {
    n = Number(n) || 0;
    var o = t.length - n;
    r ? (r = Number(r)) > o && (r = o) : r = o;
    var i = e.length;
    if (i % 2 != 0) throw new TypeError("Invalid hex string");
    r > i / 2 && (r = i / 2);
    for (var s = 0; s < r; ++s) {
      var a = parseInt(e.substr(2 * s, 2), 16);
      if (isNaN(a)) return s;
      t[n + s] = a;
    }
    return s;
  }
  function Pt(t, e, n, r) {
    return Jt(Ht(e, t.length - n), t, n, r);
  }
  function _t(t, e, n, r) {
    return Jt(function (t) {
      for (var e = [], n = 0; n < t.length; ++n) e.push(255 & t.charCodeAt(n));
      return e;
    }(e), t, n, r);
  }
  function It(t, e, n, r) {
    return _t(t, e, n, r);
  }
  function Bt(t, e, n, r) {
    return Jt(Wt(e), t, n, r);
  }
  function Ct(t, e, n, r) {
    return Jt(function (t, e) {
      for (var n, r, o, i = [], s = 0; s < t.length && !((e -= 2) < 0); ++s) r = (n = t.charCodeAt(s)) >> 8, o = n % 256, i.push(o), i.push(r);
      return i;
    }(e, t.length - n), t, n, r);
  }
  function Ot(t, e, n) {
    return 0 === e && n === t.length ? it(t) : it(t.slice(e, n));
  }
  function Ut(t, e, n) {
    n = Math.min(t.length, n);
    for (var r = [], o = e; o < n;) {
      var i,
        s,
        a,
        c,
        h = t[o],
        u = null,
        f = h > 239 ? 4 : h > 223 ? 3 : h > 191 ? 2 : 1;
      if (o + f <= n) switch (f) {
        case 1:
          h < 128 && (u = h);
          break;
        case 2:
          128 == (192 & (i = t[o + 1])) && (c = (31 & h) << 6 | 63 & i) > 127 && (u = c);
          break;
        case 3:
          i = t[o + 1], s = t[o + 2], 128 == (192 & i) && 128 == (192 & s) && (c = (15 & h) << 12 | (63 & i) << 6 | 63 & s) > 2047 && (c < 55296 || c > 57343) && (u = c);
          break;
        case 4:
          i = t[o + 1], s = t[o + 2], a = t[o + 3], 128 == (192 & i) && 128 == (192 & s) && 128 == (192 & a) && (c = (15 & h) << 18 | (63 & i) << 12 | (63 & s) << 6 | 63 & a) > 65535 && c < 1114112 && (u = c);
      }
      null === u ? (u = 65533, f = 1) : u > 65535 && (u -= 65536, r.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), r.push(u), o += f;
    }
    return function (t) {
      var e = t.length;
      if (e <= Mt) return String.fromCharCode.apply(String, t);
      var n = "",
        r = 0;
      for (; r < e;) n += String.fromCharCode.apply(String, t.slice(r, r += Mt));
      return n;
    }(r);
  }
  dt.poolSize = 8192, dt._augment = function (t) {
    return t.__proto__ = dt.prototype, t;
  }, dt.from = function (t, e, n) {
    return pt(null, t, e, n);
  }, dt.TYPED_ARRAY_SUPPORT && (dt.prototype.__proto__ = Uint8Array.prototype, dt.__proto__ = Uint8Array), dt.alloc = function (t, e, n) {
    return function (t, e, n, r) {
      return gt(e), e <= 0 ? lt(t, e) : void 0 !== n ? "string" == typeof r ? lt(t, e).fill(n, r) : lt(t, e).fill(n) : lt(t, e);
    }(null, t, e, n);
  }, dt.allocUnsafe = function (t) {
    return wt(null, t);
  }, dt.allocUnsafeSlow = function (t) {
    return wt(null, t);
  }, dt.isBuffer = Gt, dt.compare = function (t, e) {
    if (!vt(t) || !vt(e)) throw new TypeError("Arguments must be Buffers");
    if (t === e) return 0;
    for (var n = t.length, r = e.length, o = 0, i = Math.min(n, r); o < i; ++o) if (t[o] !== e[o]) {
      n = t[o], r = e[o];
      break;
    }
    return n < r ? -1 : r < n ? 1 : 0;
  }, dt.isEncoding = function (t) {
    switch (String(t).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, dt.concat = function (t, e) {
    if (!ht(t)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (0 === t.length) return dt.alloc(0);
    var n;
    if (void 0 === e) for (e = 0, n = 0; n < t.length; ++n) e += t[n].length;
    var r = dt.allocUnsafe(e),
      o = 0;
    for (n = 0; n < t.length; ++n) {
      var i = t[n];
      if (!vt(i)) throw new TypeError('"list" argument must be an Array of Buffers');
      i.copy(r, o), o += i.length;
    }
    return r;
  }, dt.byteLength = bt, dt.prototype._isBuffer = !0, dt.prototype.swap16 = function () {
    var t = this.length;
    if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var e = 0; e < t; e += 2) At(this, e, e + 1);
    return this;
  }, dt.prototype.swap32 = function () {
    var t = this.length;
    if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var e = 0; e < t; e += 4) At(this, e, e + 3), At(this, e + 1, e + 2);
    return this;
  }, dt.prototype.swap64 = function () {
    var t = this.length;
    if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var e = 0; e < t; e += 8) At(this, e, e + 7), At(this, e + 1, e + 6), At(this, e + 2, e + 5), At(this, e + 3, e + 4);
    return this;
  }, dt.prototype.toString = function () {
    var t = 0 | this.length;
    return 0 === t ? "" : 0 === arguments.length ? Ut(this, 0, t) : Et.apply(this, arguments);
  }, dt.prototype.equals = function (t) {
    if (!vt(t)) throw new TypeError("Argument must be a Buffer");
    return this === t || 0 === dt.compare(this, t);
  }, dt.prototype.inspect = function () {
    var t = "";
    return this.length > 0 && (t = this.toString("hex", 0, 50).match(/.{2}/g).join(" "), this.length > 50 && (t += " ... ")), "<Buffer " + t + ">";
  }, dt.prototype.compare = function (t, e, n, r, o) {
    if (!vt(t)) throw new TypeError("Argument must be a Buffer");
    if (void 0 === e && (e = 0), void 0 === n && (n = t ? t.length : 0), void 0 === r && (r = 0), void 0 === o && (o = this.length), e < 0 || n > t.length || r < 0 || o > this.length) throw new RangeError("out of range index");
    if (r >= o && e >= n) return 0;
    if (r >= o) return -1;
    if (e >= n) return 1;
    if (this === t) return 0;
    for (var i = (o >>>= 0) - (r >>>= 0), s = (n >>>= 0) - (e >>>= 0), a = Math.min(i, s), c = this.slice(r, o), h = t.slice(e, n), u = 0; u < a; ++u) if (c[u] !== h[u]) {
      i = c[u], s = h[u];
      break;
    }
    return i < s ? -1 : s < i ? 1 : 0;
  }, dt.prototype.includes = function (t, e, n) {
    return -1 !== this.indexOf(t, e, n);
  }, dt.prototype.indexOf = function (t, e, n) {
    return Tt(this, t, e, n, !0);
  }, dt.prototype.lastIndexOf = function (t, e, n) {
    return Tt(this, t, e, n, !1);
  }, dt.prototype.write = function (t, e, n, r) {
    if (void 0 === e) r = "utf8", n = this.length, e = 0;else if (void 0 === n && "string" == typeof e) r = e, n = this.length, e = 0;else {
      if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
      e |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
    }
    var o = this.length - e;
    if ((void 0 === n || n > o) && (n = o), t.length > 0 && (n < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    r || (r = "utf8");
    for (var i = !1;;) switch (r) {
      case "hex":
        return St(this, t, e, n);
      case "utf8":
      case "utf-8":
        return Pt(this, t, e, n);
      case "ascii":
        return _t(this, t, e, n);
      case "latin1":
      case "binary":
        return It(this, t, e, n);
      case "base64":
        return Bt(this, t, e, n);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return Ct(this, t, e, n);
      default:
        if (i) throw new TypeError("Unknown encoding: " + r);
        r = ("" + r).toLowerCase(), i = !0;
    }
  }, dt.prototype.toJSON = function () {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  var Mt = 4096;
  function Lt(t, e, n) {
    var r = "";
    n = Math.min(t.length, n);
    for (var o = e; o < n; ++o) r += String.fromCharCode(127 & t[o]);
    return r;
  }
  function Dt(t, e, n) {
    var r = "";
    n = Math.min(t.length, n);
    for (var o = e; o < n; ++o) r += String.fromCharCode(t[o]);
    return r;
  }
  function Nt(t, e, n) {
    var r = t.length;
    (!e || e < 0) && (e = 0), (!n || n < 0 || n > r) && (n = r);
    for (var o = "", i = e; i < n; ++i) o += Vt(t[i]);
    return o;
  }
  function kt(t, e, n) {
    for (var r = t.slice(e, n), o = "", i = 0; i < r.length; i += 2) o += String.fromCharCode(r[i] + 256 * r[i + 1]);
    return o;
  }
  function xt(t, e, n) {
    if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
    if (t + e > n) throw new RangeError("Trying to access beyond buffer length");
  }
  function Yt(t, e, n, r, o, i) {
    if (!vt(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (e > o || e < i) throw new RangeError('"value" argument is out of bounds');
    if (n + r > t.length) throw new RangeError("Index out of range");
  }
  function $t(t, e, n, r) {
    e < 0 && (e = 65535 + e + 1);
    for (var o = 0, i = Math.min(t.length - n, 2); o < i; ++o) t[n + o] = (e & 255 << 8 * (r ? o : 1 - o)) >>> 8 * (r ? o : 1 - o);
  }
  function jt(t, e, n, r) {
    e < 0 && (e = 4294967295 + e + 1);
    for (var o = 0, i = Math.min(t.length - n, 4); o < i; ++o) t[n + o] = e >>> 8 * (r ? o : 3 - o) & 255;
  }
  function Kt(t, e, n, r, o, i) {
    if (n + r > t.length) throw new RangeError("Index out of range");
    if (n < 0) throw new RangeError("Index out of range");
  }
  function Ft(t, e, n, r, o) {
    return o || Kt(t, 0, n, 4), at(t, e, n, r, 23, 4), n + 4;
  }
  function qt(t, e, n, r, o) {
    return o || Kt(t, 0, n, 8), at(t, e, n, r, 52, 8), n + 8;
  }
  dt.prototype.slice = function (t, e) {
    var n,
      r = this.length;
    if ((t = ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), (e = void 0 === e ? r : ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), e < t && (e = t), dt.TYPED_ARRAY_SUPPORT) (n = this.subarray(t, e)).__proto__ = dt.prototype;else {
      var o = e - t;
      n = new dt(o, void 0);
      for (var i = 0; i < o; ++i) n[i] = this[i + t];
    }
    return n;
  }, dt.prototype.readUIntLE = function (t, e, n) {
    t |= 0, e |= 0, n || xt(t, e, this.length);
    for (var r = this[t], o = 1, i = 0; ++i < e && (o *= 256);) r += this[t + i] * o;
    return r;
  }, dt.prototype.readUIntBE = function (t, e, n) {
    t |= 0, e |= 0, n || xt(t, e, this.length);
    for (var r = this[t + --e], o = 1; e > 0 && (o *= 256);) r += this[t + --e] * o;
    return r;
  }, dt.prototype.readUInt8 = function (t, e) {
    return e || xt(t, 1, this.length), this[t];
  }, dt.prototype.readUInt16LE = function (t, e) {
    return e || xt(t, 2, this.length), this[t] | this[t + 1] << 8;
  }, dt.prototype.readUInt16BE = function (t, e) {
    return e || xt(t, 2, this.length), this[t] << 8 | this[t + 1];
  }, dt.prototype.readUInt32LE = function (t, e) {
    return e || xt(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
  }, dt.prototype.readUInt32BE = function (t, e) {
    return e || xt(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
  }, dt.prototype.readIntLE = function (t, e, n) {
    t |= 0, e |= 0, n || xt(t, e, this.length);
    for (var r = this[t], o = 1, i = 0; ++i < e && (o *= 256);) r += this[t + i] * o;
    return r >= (o *= 128) && (r -= Math.pow(2, 8 * e)), r;
  }, dt.prototype.readIntBE = function (t, e, n) {
    t |= 0, e |= 0, n || xt(t, e, this.length);
    for (var r = e, o = 1, i = this[t + --r]; r > 0 && (o *= 256);) i += this[t + --r] * o;
    return i >= (o *= 128) && (i -= Math.pow(2, 8 * e)), i;
  }, dt.prototype.readInt8 = function (t, e) {
    return e || xt(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
  }, dt.prototype.readInt16LE = function (t, e) {
    e || xt(t, 2, this.length);
    var n = this[t] | this[t + 1] << 8;
    return 32768 & n ? 4294901760 | n : n;
  }, dt.prototype.readInt16BE = function (t, e) {
    e || xt(t, 2, this.length);
    var n = this[t + 1] | this[t] << 8;
    return 32768 & n ? 4294901760 | n : n;
  }, dt.prototype.readInt32LE = function (t, e) {
    return e || xt(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
  }, dt.prototype.readInt32BE = function (t, e) {
    return e || xt(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
  }, dt.prototype.readFloatLE = function (t, e) {
    return e || xt(t, 4, this.length), st(this, t, !0, 23, 4);
  }, dt.prototype.readFloatBE = function (t, e) {
    return e || xt(t, 4, this.length), st(this, t, !1, 23, 4);
  }, dt.prototype.readDoubleLE = function (t, e) {
    return e || xt(t, 8, this.length), st(this, t, !0, 52, 8);
  }, dt.prototype.readDoubleBE = function (t, e) {
    return e || xt(t, 8, this.length), st(this, t, !1, 52, 8);
  }, dt.prototype.writeUIntLE = function (t, e, n, r) {
    (t = +t, e |= 0, n |= 0, r) || Yt(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
    var o = 1,
      i = 0;
    for (this[e] = 255 & t; ++i < n && (o *= 256);) this[e + i] = t / o & 255;
    return e + n;
  }, dt.prototype.writeUIntBE = function (t, e, n, r) {
    (t = +t, e |= 0, n |= 0, r) || Yt(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
    var o = n - 1,
      i = 1;
    for (this[e + o] = 255 & t; --o >= 0 && (i *= 256);) this[e + o] = t / i & 255;
    return e + n;
  }, dt.prototype.writeUInt8 = function (t, e, n) {
    return t = +t, e |= 0, n || Yt(this, t, e, 1, 255, 0), dt.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
  }, dt.prototype.writeUInt16LE = function (t, e, n) {
    return t = +t, e |= 0, n || Yt(this, t, e, 2, 65535, 0), dt.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : $t(this, t, e, !0), e + 2;
  }, dt.prototype.writeUInt16BE = function (t, e, n) {
    return t = +t, e |= 0, n || Yt(this, t, e, 2, 65535, 0), dt.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : $t(this, t, e, !1), e + 2;
  }, dt.prototype.writeUInt32LE = function (t, e, n) {
    return t = +t, e |= 0, n || Yt(this, t, e, 4, 4294967295, 0), dt.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : jt(this, t, e, !0), e + 4;
  }, dt.prototype.writeUInt32BE = function (t, e, n) {
    return t = +t, e |= 0, n || Yt(this, t, e, 4, 4294967295, 0), dt.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : jt(this, t, e, !1), e + 4;
  }, dt.prototype.writeIntLE = function (t, e, n, r) {
    if (t = +t, e |= 0, !r) {
      var o = Math.pow(2, 8 * n - 1);
      Yt(this, t, e, n, o - 1, -o);
    }
    var i = 0,
      s = 1,
      a = 0;
    for (this[e] = 255 & t; ++i < n && (s *= 256);) t < 0 && 0 === a && 0 !== this[e + i - 1] && (a = 1), this[e + i] = (t / s >> 0) - a & 255;
    return e + n;
  }, dt.prototype.writeIntBE = function (t, e, n, r) {
    if (t = +t, e |= 0, !r) {
      var o = Math.pow(2, 8 * n - 1);
      Yt(this, t, e, n, o - 1, -o);
    }
    var i = n - 1,
      s = 1,
      a = 0;
    for (this[e + i] = 255 & t; --i >= 0 && (s *= 256);) t < 0 && 0 === a && 0 !== this[e + i + 1] && (a = 1), this[e + i] = (t / s >> 0) - a & 255;
    return e + n;
  }, dt.prototype.writeInt8 = function (t, e, n) {
    return t = +t, e |= 0, n || Yt(this, t, e, 1, 127, -128), dt.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
  }, dt.prototype.writeInt16LE = function (t, e, n) {
    return t = +t, e |= 0, n || Yt(this, t, e, 2, 32767, -32768), dt.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : $t(this, t, e, !0), e + 2;
  }, dt.prototype.writeInt16BE = function (t, e, n) {
    return t = +t, e |= 0, n || Yt(this, t, e, 2, 32767, -32768), dt.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : $t(this, t, e, !1), e + 2;
  }, dt.prototype.writeInt32LE = function (t, e, n) {
    return t = +t, e |= 0, n || Yt(this, t, e, 4, 2147483647, -2147483648), dt.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : jt(this, t, e, !0), e + 4;
  }, dt.prototype.writeInt32BE = function (t, e, n) {
    return t = +t, e |= 0, n || Yt(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), dt.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : jt(this, t, e, !1), e + 4;
  }, dt.prototype.writeFloatLE = function (t, e, n) {
    return Ft(this, t, e, !0, n);
  }, dt.prototype.writeFloatBE = function (t, e, n) {
    return Ft(this, t, e, !1, n);
  }, dt.prototype.writeDoubleLE = function (t, e, n) {
    return qt(this, t, e, !0, n);
  }, dt.prototype.writeDoubleBE = function (t, e, n) {
    return qt(this, t, e, !1, n);
  }, dt.prototype.copy = function (t, e, n, r) {
    if (n || (n = 0), r || 0 === r || (r = this.length), e >= t.length && (e = t.length), e || (e = 0), r > 0 && r < n && (r = n), r === n) return 0;
    if (0 === t.length || 0 === this.length) return 0;
    if (e < 0) throw new RangeError("targetStart out of bounds");
    if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
    if (r < 0) throw new RangeError("sourceEnd out of bounds");
    r > this.length && (r = this.length), t.length - e < r - n && (r = t.length - e + n);
    var o,
      i = r - n;
    if (this === t && n < e && e < r) for (o = i - 1; o >= 0; --o) t[o + e] = this[o + n];else if (i < 1e3 || !dt.TYPED_ARRAY_SUPPORT) for (o = 0; o < i; ++o) t[o + e] = this[o + n];else Uint8Array.prototype.set.call(t, this.subarray(n, n + i), e);
    return i;
  }, dt.prototype.fill = function (t, e, n, r) {
    if ("string" == typeof t) {
      if ("string" == typeof e ? (r = e, e = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === t.length) {
        var o = t.charCodeAt(0);
        o < 256 && (t = o);
      }
      if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
      if ("string" == typeof r && !dt.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
    } else "number" == typeof t && (t &= 255);
    if (e < 0 || this.length < e || this.length < n) throw new RangeError("Out of range index");
    if (n <= e) return this;
    var i;
    if (e >>>= 0, n = void 0 === n ? this.length : n >>> 0, t || (t = 0), "number" == typeof t) for (i = e; i < n; ++i) this[i] = t;else {
      var s = vt(t) ? t : Ht(new dt(t, r).toString()),
        a = s.length;
      for (i = 0; i < n - e; ++i) this[i + e] = s[i % a];
    }
    return this;
  };
  var zt = /[^+\/0-9A-Za-z-_]/g;
  function Vt(t) {
    return t < 16 ? "0" + t.toString(16) : t.toString(16);
  }
  function Ht(t, e) {
    var n;
    e = e || 1 / 0;
    for (var r = t.length, o = null, i = [], s = 0; s < r; ++s) {
      if ((n = t.charCodeAt(s)) > 55295 && n < 57344) {
        if (!o) {
          if (n > 56319) {
            (e -= 3) > -1 && i.push(239, 191, 189);
            continue;
          }
          if (s + 1 === r) {
            (e -= 3) > -1 && i.push(239, 191, 189);
            continue;
          }
          o = n;
          continue;
        }
        if (n < 56320) {
          (e -= 3) > -1 && i.push(239, 191, 189), o = n;
          continue;
        }
        n = 65536 + (o - 55296 << 10 | n - 56320);
      } else o && (e -= 3) > -1 && i.push(239, 191, 189);
      if (o = null, n < 128) {
        if ((e -= 1) < 0) break;
        i.push(n);
      } else if (n < 2048) {
        if ((e -= 2) < 0) break;
        i.push(n >> 6 | 192, 63 & n | 128);
      } else if (n < 65536) {
        if ((e -= 3) < 0) break;
        i.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
      } else {
        if (!(n < 1114112)) throw new Error("Invalid code point");
        if ((e -= 4) < 0) break;
        i.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
      }
    }
    return i;
  }
  function Wt(t) {
    return function (t) {
      var e, n, r, o, i, s;
      nt || rt();
      var a = t.length;
      if (a % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      i = "=" === t[a - 2] ? 2 : "=" === t[a - 1] ? 1 : 0, s = new et(3 * a / 4 - i), r = i > 0 ? a - 4 : a;
      var c = 0;
      for (e = 0, n = 0; e < r; e += 4, n += 3) o = tt[t.charCodeAt(e)] << 18 | tt[t.charCodeAt(e + 1)] << 12 | tt[t.charCodeAt(e + 2)] << 6 | tt[t.charCodeAt(e + 3)], s[c++] = o >> 16 & 255, s[c++] = o >> 8 & 255, s[c++] = 255 & o;
      return 2 === i ? (o = tt[t.charCodeAt(e)] << 2 | tt[t.charCodeAt(e + 1)] >> 4, s[c++] = 255 & o) : 1 === i && (o = tt[t.charCodeAt(e)] << 10 | tt[t.charCodeAt(e + 1)] << 4 | tt[t.charCodeAt(e + 2)] >> 2, s[c++] = o >> 8 & 255, s[c++] = 255 & o), s;
    }(function (t) {
      if ((t = function (t) {
        return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
      }(t).replace(zt, "")).length < 2) return "";
      for (; t.length % 4 != 0;) t += "=";
      return t;
    }(t));
  }
  function Jt(t, e, n, r) {
    for (var o = 0; o < r && !(o + n >= e.length || o >= t.length); ++o) e[o + n] = t[o];
    return o;
  }
  function Gt(t) {
    return null != t && (!!t._isBuffer || Xt(t) || function (t) {
      return "function" == typeof t.readFloatLE && "function" == typeof t.slice && Xt(t.slice(0, 0));
    }(t));
  }
  function Xt(t) {
    return !!t.constructor && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
  }
  var Zt = Object.freeze({
    __proto__: null,
    Buffer: dt,
    INSPECT_MAX_BYTES: 50,
    SlowBuffer: function (t) {
      return +t != t && (t = 0), dt.alloc(+t);
    },
    isBuffer: Gt,
    kMaxLength: ut
  });
  function Qt(t) {
    return t && t.default || t;
  }
  var te = function (t, e) {
    return t(e = {
      exports: {}
    }, e.exports), e.exports;
  }(function (t, e) {
    /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
    var n = Zt.Buffer;
    function r(t, e) {
      for (var n in t) e[n] = t[n];
    }
    function o(t, e, r) {
      return n(t, e, r);
    }
    n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? t.exports = Zt : (r(Zt, e), e.Buffer = o), o.prototype = Object.create(n.prototype), r(n, o), o.from = function (t, e, r) {
      if ("number" == typeof t) throw new TypeError("Argument must not be a number");
      return n(t, e, r);
    }, o.alloc = function (t, e, r) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      var o = n(t);
      return void 0 !== e ? "string" == typeof r ? o.fill(e, r) : o.fill(e) : o.fill(0), o;
    }, o.allocUnsafe = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return n(t);
    }, o.allocUnsafeSlow = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return Zt.SlowBuffer(t);
    };
  });
  te.Buffer;
  var ee = te.Buffer;
  var ne = function (t) {
      if (t.length >= 255) throw new TypeError("Alphabet too long");
      for (var e = new Uint8Array(256), n = 0; n < e.length; n++) e[n] = 255;
      for (var r = 0; r < t.length; r++) {
        var o = t.charAt(r),
          i = o.charCodeAt(0);
        if (255 !== e[i]) throw new TypeError(o + " is ambiguous");
        e[i] = r;
      }
      var s = t.length,
        a = t.charAt(0),
        c = Math.log(s) / Math.log(256),
        h = Math.log(256) / Math.log(s);
      function u(t) {
        if ("string" != typeof t) throw new TypeError("Expected String");
        if (0 === t.length) return ee.alloc(0);
        for (var n = 0, r = 0, o = 0; t[n] === a;) r++, n++;
        for (var i = (t.length - n) * c + 1 >>> 0, h = new Uint8Array(i); t[n];) {
          var u = e[t.charCodeAt(n)];
          if (255 === u) return;
          for (var f = 0, l = i - 1; (0 !== u || f < o) && -1 !== l; l--, f++) u += s * h[l] >>> 0, h[l] = u % 256 >>> 0, u = u / 256 >>> 0;
          if (0 !== u) throw new Error("Non-zero carry");
          o = f, n++;
        }
        for (var d = i - o; d !== i && 0 === h[d];) d++;
        var p = ee.allocUnsafe(r + (i - d));
        p.fill(0, 0, r);
        for (var g = r; d !== i;) p[g++] = h[d++];
        return p;
      }
      return {
        encode: function (e) {
          if ((Array.isArray(e) || e instanceof Uint8Array) && (e = ee.from(e)), !ee.isBuffer(e)) throw new TypeError("Expected Buffer");
          if (0 === e.length) return "";
          for (var n = 0, r = 0, o = 0, i = e.length; o !== i && 0 === e[o];) o++, n++;
          for (var c = (i - o) * h + 1 >>> 0, u = new Uint8Array(c); o !== i;) {
            for (var f = e[o], l = 0, d = c - 1; (0 !== f || l < r) && -1 !== d; d--, l++) f += 256 * u[d] >>> 0, u[d] = f % s >>> 0, f = f / s >>> 0;
            if (0 !== f) throw new Error("Non-zero carry");
            r = l, o++;
          }
          for (var p = c - r; p !== c && 0 === u[p];) p++;
          for (var g = a.repeat(n); p < c; ++p) g += t.charAt(u[p]);
          return g;
        },
        decodeUnsafe: u,
        decode: function (t) {
          var e = u(t);
          if (e) return e;
          throw new Error("Non-base" + s + " character");
        }
      };
    },
    re = ne("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
  let oe;
  try {
    oe = require("@solana/web3.js");
  } catch (_unused) {}
  class ie extends $ {
    constructor(_ref4) {
      let {
        net: t = "mainnet-beta",
        server: e,
        appId: n,
        rpc: r
      } = _ref4;
      if (super(), this.accounts = [], P(t, "'net' is required"), P(U.includes(t), "unsupported net"), this.net = t, this.rpc = r || ("mainnet-beta" === t ? "https://free.rpcpool.com" : "https://api.".concat(t, ".solana.com")), this.server = e || O[this.net] || process.env.SERVER || "", this.appId = n || process.env.APP_ID, !oe) throw new Error("No @solana/web3.js installed. Please install it to interact with Solana.");
    }
    tryRetrieveSessionFromStorage() {
      const t = H(this.sessionKey, {}),
        e = t && t.code,
        n = t && t.address && t.address.solana;
      this.connected = Boolean(e && n), this.code = e || null, this.accounts = n ? [n] : [];
    }
    async request(t) {
      this.connected || (await this.connect());
      try {
        let e = null,
          n = null;
        switch (t.method) {
          case "connect":
            n = await this.fetchAccounts();
            break;
          case "disconnect":
            this.disconnect();
            break;
          case "getAccounts":
            n = this.accounts.length ? this.accounts : await this.fetchAccounts();
            break;
          case "getAccountInfo":
            {
              const e = await this.handleReadRequests(t),
                [r, o] = e.result.value.data;
              n = _objectSpread(_objectSpread({}, e.result.value), {}, {
                data: dt.from(r, o),
                owner: new oe.PublicKey(e.result.value.owner)
              });
              break;
            }
          case "convertToProgramWalletTransaction":
            n = await this.handleConvertTransaction(t);
            break;
          case "signAndSendTransaction":
            n = await this.handleSignAndSendTransaction(t);
            break;
          case "signTransaction":
          case "signAllTransactions":
            throw new Error("Blocto is program wallet, which doesn't support ".concat(t.method, ". Use signAndSendTransaction instead."));
          default:
            e = await this.handleReadRequests(t);
        }
        if (e && !e.result && e.error) {
          const t = e.error.message ? e.error.message : "Request failed";
          throw new Error(t);
        }
        return e ? e.result : n;
      } catch (t) {
        throw console.error(t), t;
      }
    }
    async connect() {
      const t = window.solana;
      return t && t.isBlocto ? new Promise(e => {
        t.on("connect", () => {
          this.accounts = [t.publicKey.toBase58()], e();
        }), t.connect();
      }) : (this.tryRetrieveSessionFromStorage(), new Promise((t, e) => {
        if ("undefined" == typeof window && e("Currently only supported in browser"), this.connected) return t();
        const n = encodeURIComponent(window.location.origin),
          r = j("".concat(this.server, "/authn?l6n=").concat(n, "&chain=solana"));
        K(r), q("message", (n, o) => {
          const i = n;
          if (i.origin === this.server) {
            if ("FCL::CHALLENGE::RESPONSE" === i.data.type) {
              o(), F(r), this.code = i.data.code, this.connected = !0, this.eventListeners.connect.forEach(t => t(this.net));
              const e = i.data.address;
              this.accounts = e ? [e.solana] : [], J(this.sessionKey, {
                code: this.code,
                address: e
              }, x), t();
            }
            "FCL::CHALLENGE::CANCEL" === i.data.type && (o(), F(r), e(new Error("User declined the login request")));
          }
        });
      }));
    }
    async disconnect() {
      const t = window.solana;
      t && t.isBlocto ? await t.disconnect() : (this.code = null, this.accounts = [], this.eventListeners.disconnect.forEach(t => t()), this.connected = !1);
    }
    async fetchAccounts() {
      const {
        accounts: t
      } = await fetch("".concat(this.server, "/api/solana/accounts?code=").concat(this.code)).then(t => t.json());
      return this.accounts = t, t;
    }
    async handleReadRequests(t) {
      return fetch(this.rpc, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(_objectSpread({
          id: 1,
          jsonrpc: "2.0"
        }, t))
      }).then(t => t.json());
    }
    async convertToProgramWalletTransaction(t) {
      const e = window.solana;
      if (e && e.isBlocto) return e.convertToProgramWalletTransaction(t);
      const n = await this.request({
        method: "convertToProgramWalletTransaction",
        params: {
          message: t.serializeMessage().toString("hex")
        }
      });
      return this.toTransaction(n, []);
    }
    async signAndSendTransaction(t, e) {
      const n = window.solana;
      if (n && n.isBlocto) return n.signAndSendTransaction(t);
      const r = {};
      if (e) {
        e.commitment && (r.commitment = e.commitment);
        const t = e ? e._rpcEndpoint : null;
        t && t !== this.rpc && (this.rpc = t, this.disconnect(), await this.connect());
      }
      return this.request({
        method: "signAndSendTransaction",
        params: _objectSpread({
          signatures: await this.collectSignatures(t),
          message: t.serializeMessage().toString("hex")
        }, r)
      });
    }
    async toTransaction(t, e) {
      const n = oe.Message.from(dt.from(t, "hex")),
        r = new oe.Transaction();
      return r.recentBlockhash = n.recentBlockhash, n.header.numRequiredSignatures > 0 && (r.feePayer = n.accountKeys[0]), e.forEach((t, e) => {
        const o = {
          signature: t === oe.PublicKey.default.toBase58() ? null : re.decode(t),
          publicKey: n.accountKeys[e]
        };
        r.signatures.push(o);
      }), n.instructions.forEach(t => {
        const e = t.accounts.map(t => ({
          pubkey: n.accountKeys[t],
          isSigner: t < n.header.numRequiredSignatures,
          isWritable: n.isAccountWritable(t)
        }));
        r.instructions.push(new oe.TransactionInstruction({
          keys: e,
          programId: n.accountKeys[t.programIdIndex],
          data: re.decode(t.data)
        }));
      }), r;
    }
    async collectSignatures(t) {
      return t.signatures.reduce((t, e) => (e.signature && (t[e.publicKey.toBase58()] = e.signature.toString("hex")), t), {});
    }
    async handleConvertTransaction(t) {
      return fetch("".concat(this.server, "/api/solana/convertToWalletTx?code=").concat(this.code), {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(_objectSpread({
          sessionId: this.code
        }, t.params))
      }).then(t => X(t, this));
    }
    async handleSignAndSendTransaction(t) {
      const {
        authorizationId: e
      } = await fetch("".concat(this.server, "/api/solana/authz?code=").concat(this.code), {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(_objectSpread({
          sessionId: this.code
        }, t.params))
      }).then(t => X(t, this));
      if ("undefined" == typeof window) throw new Error("Currently only supported in browser");
      const n = j("".concat(this.server, "/authz/solana/").concat(e));
      return K(n), new Promise((t, e) => q("message", (r, o) => {
        const i = r;
        i.origin === this.server && "SOL:FRAME:RESPONSE" === i.data.type && ("APPROVED" === i.data.status && (o(), F(n), t(i.data.txHash)), "DECLINED" === i.data.status && (o(), F(n), e(new Error(i.data.errorMessage))));
      }));
    }
  }
  class se extends $ {
    constructor(_ref5) {
      let {
        chainId: t,
        server: e,
        appId: n
      } = _ref5;
      super(), this.publicKey = [], this.authKey = "", P(t, "'chainId' is required"), P(n, "It is necessary to interact with Blocto wallet via your app id. Please visit https://developers.blocto.app for more details."), this.chainId = t, this.networkName = D[t], this.api = N[t];
      const r = M[t];
      this.appId = n || process.env.APP_ID, this.server = e || r || process.env.SERVER || "";
    }
    tryRetrieveSessionFromStorage() {
      const t = H(this.sessionKey, {}),
        e = t && t.code,
        n = t && t.address && t.address[this.chainId];
      this.code = e || null, this.address = n || void 0;
    }
    get publicAccount() {
      return {
        address: this.address || null,
        publicKey: this.publicKey.length ? this.publicKey : null,
        authKey: null,
        minKeysRequired: 2
      };
    }
    async network() {
      return {
        name: this.networkName,
        api: this.api,
        chainId: this.chainId.toString()
      };
    }
    async isConnected() {
      return !!this.address;
    }
    async signTransaction(t) {
      const e = window.bloctoAptos;
      if (e) return e.signTransaction(t);
      if ((await this.isConnected()) || (await this.connect()), !this.address) throw new Error("Fail to get account");
      throw new Error("signTransaction method not supported.");
    }
    async disconnect() {
      const t = window.bloctoAptos;
      t ? await t.disconnect() : (this.code = null, this.address = void 0, this.connected = !1);
    }
    async signAndSubmitTransaction(t) {
      let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const n = window.bloctoAptos;
      if (n) return n.signAndSubmitTransaction(t, e);
      if ((await this.isConnected()) || (await this.connect()), !this.address) throw new Error("Fail to get account");
      const {
        authorizationId: r
      } = await fetch("".concat(this.server, "/api/aptos/authz?code=").concat(this.code), {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(_objectSpread(_objectSpread({}, t), e))
      }).then(t => X(t, this));
      if ("undefined" == typeof window) throw new Error("Currently only supported in browser");
      const o = j("".concat(this.server, "/authz/aptos/").concat(r));
      return K(o), new Promise((t, e) => q("message", (n, r) => {
        const i = n;
        i.origin === this.server && "APTOS:FRAME:RESPONSE" === i.data.type && ("APPROVED" === i.data.status && (r(), F(o), t({
          hash: i.data.txHash
        })), "DECLINED" === i.data.status && (r(), F(o), e(new Error(i.data.errorMessage))));
      }));
    }
    async signMessage(t) {
      const e = window.bloctoAptos;
      if (e) return e.signMessage(t);
      if ((await this.isConnected()) || (await this.connect()), !this.address) throw new Error("Fail to get account");
      const n = "".concat(this.server, "/user-signature/aptos"),
        r = j(n);
      return K(r), q("message", (e, o) => {
        const i = e;
        i.origin === this.server && "APTOS:FRAME:READY" === i.data.type && (r.contentWindow && r.contentWindow.postMessage(_objectSpread({
          type: "APTOS:FRAME:READY:RESPONSE"
        }, t), n), o());
      }), new Promise((e, n) => q("message", (o, i) => {
        const s = o;
        s.origin === this.server && "APTOS:FRAME:RESPONSE" === s.data.type && ("APPROVED" === s.data.status && (i(), F(r), e({
          address: s.data.address,
          application: s.data.application,
          chainId: s.data.chainId,
          fullMessage: s.data.fullMessage,
          message: t.message,
          nonce: t.nonce,
          prefix: "APTOS",
          signature: s.data.signature,
          bitmap: s.data.bitmap
        })), "DECLINED" === s.data.status && (i(), F(r), n(new Error(s.data.errorMessage))));
      }));
    }
    async connect() {
      const t = window.bloctoAptos;
      return t ? new Promise((e, n) => setTimeout(() => t.connect().then(e).catch(n), 10)) : (this.tryRetrieveSessionFromStorage(), new Promise((t, e) => {
        "undefined" == typeof window && e("Currently only supported in browser"), this.connected && this.address && t({
          address: this.address,
          publicKey: this.publicKey,
          authKey: null,
          minKeysRequired: 2
        });
        const n = encodeURIComponent(window.location.origin),
          r = j("".concat(this.server, "/authn?l6n=").concat(n, "&chain=aptos&appId=").concat(this.appId));
        K(r), q("message", async (n, o) => {
          const i = n;
          if (i.origin === this.server) {
            if ("APTOS:FRAME:RESPONSE" === i.data.type) {
              o(), F(r), this.code = i.data.code, this.connected = !0;
              const n = i.data.address;
              if (this.address = n ? n.aptos : void 0, !this.address) return e();
              try {
                const {
                  public_keys: e
                } = await fetch("".concat(this.server, "/blocto/aptos/accounts/").concat(this.address)).then(t => t.json());
                this.publicKey = e || [], t({
                  address: this.address || "",
                  publicKey: this.publicKey,
                  authKey: null,
                  minKeysRequired: 2
                });
              } catch (t) {
                e(i);
              }
              J(this.sessionKey, {
                code: this.code,
                address: n
              }, x);
            }
            "APTOS:FRAME:CLOSE" === i.data.type && (o(), F(r), e(new Error("User declined the login request")));
          }
        });
      }));
    }
    async fetchAddress() {
      const {
        accounts: t
      } = await fetch("".concat(this.server, "/api/aptos/accounts?code=").concat(this.code)).then(t => X(t, this));
      return this.address = t[0] || void 0, this.address;
    }
  }
  var ae = Object.freeze({
    __proto__: null,
    default: {}
  });
  function ce(t, e) {
    for (var n = 0, r = t.length - 1; r >= 0; r--) {
      var o = t[r];
      "." === o ? t.splice(r, 1) : ".." === o ? (t.splice(r, 1), n++) : n && (t.splice(r, 1), n--);
    }
    if (e) for (; n--; n) t.unshift("..");
    return t;
  }
  var he = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,
    ue = function (t) {
      return he.exec(t).slice(1);
    };
  function fe() {
    for (var t = "", e = !1, n = arguments.length - 1; n >= -1 && !e; n--) {
      var r = n >= 0 ? arguments[n] : "/";
      if ("string" != typeof r) throw new TypeError("Arguments to path.resolve must be strings");
      r && (t = r + "/" + t, e = "/" === r.charAt(0));
    }
    return (e ? "/" : "") + (t = ce(be(t.split("/"), function (t) {
      return !!t;
    }), !e).join("/")) || ".";
  }
  function le(t) {
    var e = de(t),
      n = "/" === Ae(t, -1);
    return (t = ce(be(t.split("/"), function (t) {
      return !!t;
    }), !e).join("/")) || e || (t = "."), t && n && (t += "/"), (e ? "/" : "") + t;
  }
  function de(t) {
    return "/" === t.charAt(0);
  }
  function pe() {
    var t = Array.prototype.slice.call(arguments, 0);
    return le(be(t, function (t, e) {
      if ("string" != typeof t) throw new TypeError("Arguments to path.join must be strings");
      return t;
    }).join("/"));
  }
  function ge(t, e) {
    function n(t) {
      for (var e = 0; e < t.length && "" === t[e]; e++);
      for (var n = t.length - 1; n >= 0 && "" === t[n]; n--);
      return e > n ? [] : t.slice(e, n - e + 1);
    }
    t = fe(t).substr(1), e = fe(e).substr(1);
    for (var r = n(t.split("/")), o = n(e.split("/")), i = Math.min(r.length, o.length), s = i, a = 0; a < i; a++) if (r[a] !== o[a]) {
      s = a;
      break;
    }
    var c = [];
    for (a = s; a < r.length; a++) c.push("..");
    return (c = c.concat(o.slice(s))).join("/");
  }
  function we(t) {
    var e = ue(t),
      n = e[0],
      r = e[1];
    return n || r ? (r && (r = r.substr(0, r.length - 1)), n + r) : ".";
  }
  function ye(t, e) {
    var n = ue(t)[2];
    return e && n.substr(-1 * e.length) === e && (n = n.substr(0, n.length - e.length)), n;
  }
  function me(t) {
    return ue(t)[3];
  }
  var ve = {
    extname: me,
    basename: ye,
    dirname: we,
    sep: "/",
    delimiter: ":",
    relative: ge,
    join: pe,
    isAbsolute: de,
    normalize: le,
    resolve: fe
  };
  function be(t, e) {
    if (t.filter) return t.filter(e);
    for (var n = [], r = 0; r < t.length; r++) e(t[r], r, t) && n.push(t[r]);
    return n;
  }
  var Ee,
    Ae = "b" === "ab".substr(-1) ? function (t, e, n) {
      return t.substr(e, n);
    } : function (t, e, n) {
      return e < 0 && (e = t.length + e), t.substr(e, n);
    },
    Te = Object.freeze({
      __proto__: null,
      resolve: fe,
      normalize: le,
      isAbsolute: de,
      join: pe,
      relative: ge,
      sep: "/",
      delimiter: ":",
      dirname: we,
      basename: ye,
      extname: me,
      default: ve
    });
  function Re() {
    if (void 0 === Ee) {
      var t = new ArrayBuffer(2),
        e = new Uint8Array(t),
        n = new Uint16Array(t);
      if (e[0] = 1, e[1] = 2, 258 === n[0]) Ee = "BE";else {
        if (513 !== n[0]) throw new Error("unable to figure out endianess");
        Ee = "LE";
      }
    }
    return Ee;
  }
  function Se() {
    return void 0 !== t.location ? t.location.hostname : "";
  }
  function Pe() {
    return [];
  }
  function _e() {
    return 0;
  }
  function Ie() {
    return Number.MAX_VALUE;
  }
  function Be() {
    return Number.MAX_VALUE;
  }
  function Ce() {
    return [];
  }
  function Oe() {
    return "Browser";
  }
  function Ue() {
    return void 0 !== t.navigator ? t.navigator.appVersion : "";
  }
  function Me() {}
  function Le() {}
  function De() {
    return "/tmp";
  }
  var Ne = De,
    ke = {
      EOL: "\n",
      tmpdir: Ne,
      tmpDir: De,
      networkInterfaces: Me,
      getNetworkInterfaces: Le,
      release: Ue,
      type: Oe,
      cpus: Ce,
      totalmem: Be,
      freemem: Ie,
      uptime: _e,
      loadavg: Pe,
      hostname: Se,
      endianness: Re
    },
    xe = Object.freeze({
      __proto__: null,
      endianness: Re,
      hostname: Se,
      loadavg: Pe,
      uptime: _e,
      freemem: Ie,
      totalmem: Be,
      cpus: Ce,
      type: Oe,
      release: Ue,
      networkInterfaces: Me,
      getNetworkInterfaces: Le,
      arch: function () {
        return "javascript";
      },
      platform: function () {
        return "browser";
      },
      tmpDir: De,
      tmpdir: Ne,
      EOL: "\n",
      default: ke
    }),
    Ye = Qt(ae),
    $e = Qt(Te),
    je = Qt(xe);
  function Ke(t) {
    console.log("[dotenv][DEBUG] ".concat(t));
  }
  const Fe = /^\s*([\w.-]+)\s*=\s*(.*)?\s*$/,
    qe = /\\n/g,
    ze = /\r\n|\n|\r/;
  function Ve(t, e) {
    const n = Boolean(e && e.debug),
      r = {};
    return t.toString().split(ze).forEach(function (t, e) {
      const o = t.match(Fe);
      if (null != o) {
        const t = o[1];
        let e = o[2] || "";
        const n = e.length - 1,
          i = '"' === e[0] && '"' === e[n];
        "'" === e[0] && "'" === e[n] || i ? (e = e.substring(1, n), i && (e = e.replace(qe, "\n"))) : e = e.trim(), r[t] = e;
      } else n && Ke("did not match key and value when parsing line ".concat(e + 1, ": ").concat(t));
    }), r;
  }
  ({
    config: function (t) {
      let e = $e.resolve(S.cwd(), ".env"),
        n = "utf8",
        r = !1;
      var o;
      t && (null != t.path && (e = "~" === (o = t.path)[0] ? $e.join(je.homedir(), o.slice(1)) : o), null != t.encoding && (n = t.encoding), null != t.debug && (r = !0));
      try {
        const t = Ve(Ye.readFileSync(e, {
          encoding: n
        }), {
          debug: r
        });
        return Object.keys(t).forEach(function (e) {
          Object.prototype.hasOwnProperty.call(S.env, e) ? r && Ke("\"".concat(e, "\" is already defined in `process.env` and will not be overwritten")) : S.env[e] = t[e];
        }), {
          parsed: t
        };
      } catch (t) {
        return {
          error: t
        };
      }
    },
    parse: Ve
  }).config();
  return class {
    constructor(_ref6) {
      let {
        appId: t,
        ethereum: e,
        solana: n,
        aptos: r
      } = _ref6;
      e && (this.ethereum = new Z(_objectSpread(_objectSpread({}, e), {}, {
        appId: t
      }))), n && (this.solana = new ie(_objectSpread(_objectSpread({}, n), {}, {
        appId: t
      }))), r && (this.aptos = new se(_objectSpread(_objectSpread({}, r), {}, {
        appId: t
      })));
    }
  };
});